import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { classList } from 'utils/componentsCommon';
import { LoaderTriviaCategory } from 'utils/enums';


const Loader = ( { className = '', modal, blur, show, delay, delayfunc, waitText, triviaCategory = LoaderTriviaCategory.Default, ...props }) => {
    let triviaTextIndex = 0;
    const [showLoader, setShowLoader] = useState(show);
    const [texts, setTexts] = useState(null);
    const loaderTriviaTexts = {
        pension: [
            'hver 3. dansker på +60 år har mindst 6 pensionsopsparinger.',
            'hver 2. dansker mellem 40-50 år har mindst 3 pensionsopsparinger.',
            'hvis du sparer 800 kr. i gebyrer om året, får du 45.400 kr. mere udbetalt efter 30 år.',
            'klatpensioner koster danskerne mere end 7 mia. kr. i tabt pensionsopsparing.',
        ],
    };
    const classNames = classList(
        modal ? 'modal' : '',
        blur ? 'blur' : '',
        !show ? 'hide': '',
        className);

    useEffect(() => {
        if (show) {
            setShowLoader(true);
            if (delay && delayfunc) {
                setTimeout(() => {
                    setShowLoader(false);
                }, delay);
                setTimeout(delayfunc, delay);
            }
        }
    }, [show, delay, delayfunc]);

    useEffect(() => {
        if (show && triviaCategory !== LoaderTriviaCategory.Default && (!texts || texts.length === 0)) {
            let triviaTexts = null;
            if (triviaCategory === LoaderTriviaCategory.Pension) {
                triviaTexts = loaderTriviaTexts.pension;
            }

            const randomizedTexts = [];

            while (triviaTexts.length > 0) {
                const randomIndex = Math.floor(Math.random() * triviaTexts.length);
                const text = triviaTexts[randomIndex];
                randomizedTexts.push(text);
                triviaTexts = triviaTexts.filter(t => t !== text);
            }
            setTexts(randomizedTexts);
        }
    }, [show]);

    const fadeInterval = 2000;
    const triviaSwitchInterval = 4000;

    useEffect(() => {
        if (show && triviaCategory !== LoaderTriviaCategory.Default && texts !== null) {
            setTimeout(() => {
                loadNewTrivia();
            }, triviaSwitchInterval);
        }
    }, [texts]);

    const loadNewTrivia = () => {
        if (show) {
            const currentText = document.getElementById(`triviaText${triviaTextIndex}`);
            triviaTextIndex = triviaTextIndex < (texts.length - 1) ? triviaTextIndex + 1 : 0;
            const nextText = document.getElementById(`triviaText${triviaTextIndex}`);

            if (currentText && nextText) {
                setTimeout(() => {
                    currentText.classList.remove('show');
                    currentText.classList.add('hide');
                    setTimeout(() => {
                        currentText.classList.remove('hide');
                        nextText.classList.add('show');
                        setTimeout(() => {
                            setTimeout(() => {
                                loadNewTrivia();
                            }, triviaSwitchInterval);
                        }, fadeInterval);
                    }, fadeInterval);
                }, fadeInterval);
            }
        }
    };

    const getInitialTextClass = (index) => index === 0 ? 'show' : '';

    const onAnimationEnd = () => {
        if (!show) setShowLoader(false);
    };

    return <>
        { showLoader &&
        <div id="loader" onAnimationEnd={ onAnimationEnd } className={ classNames } { ...props }>
            <div>
                { triviaCategory !== LoaderTriviaCategory.Default ?
                    <object className="search" type="image/svg+xml" data="/static/gfx/PenlyLoaderSearch.svg"></object>
                    :
                    <object className="default" type="image/svg+xml" data="/static/gfx/PenlyLoader.svg"></object>
                }
                <div>
                    { waitText }
                </div>
            </div>
            { triviaCategory !== LoaderTriviaCategory.Default &&
            <div className="triviaTexts">
                <div>
                    <h4>Vidste du at...</h4>
                    { texts && texts.map((text, index) =>
                        <div id={ `triviaText${index}` } className={ getInitialTextClass(index) } key={ text }>{ text }</div>,
                    ) }
                </div>
            </div>
            }
        </div>
        }
    </>;
};

Loader.propTypes = {
    show: PropTypes.bool,
    modal: PropTypes.bool,
    blur: PropTypes.bool,
    className: PropTypes.string,
    delay: PropTypes.number,
    delayfunc: PropTypes.func,
    waitText: PropTypes.string,
    triviaCategory: PropTypes.any,
};

Loader.defaultProps = {
    show: false,
    modal: true,
    blur: true,
    delay: null,
    delayfunc: null,
    waitText: null,
    triviaCategory: LoaderTriviaCategory.Default,
};

export default Loader;
